<div class="globalSearch">
  <div class="search-field-header">
    <div (click)="toggle($event)" class="pointer"
         style="border: 1px solid #D0D5DD;border-radius: 4px;padding: 10px 14px;">
      <span *ngIf="searchTags.length > 3" style="font-size: 25px;margin:0 5px;">...</span>
      <img src="../../../images/tpiq-icons/SVG/filter.svg"> Filters
    </div>
  </div>
</div>

<div *ngIf="reveal['search']">
  <div [ngClass]="{'tpiq-reveal': reveal['search']}" class="reveal-overlay">
    <div [ngClass]="{'tpiq-reveal': reveal['search']}"
         class="reveal tax-strategy-reveal"
         style="width: 50% !important;overflow: initial;padding-bottom: 20px !important;">
      <div style="height: 50px; padding: 15px; color: #333333;">
        <span class="float-left">Search</span>
        <span (click)="hideReveal('search')" class="float-right pointer">X</span>
      </div>
      <div style="padding: 0 15px;">
        <hr style="margin: 0;"/>
      </div>

      <div class="body reveal-publish new-input-fields" style="padding: 15px;">
        <div class="row row-padding-reveal">
          <div class="small-12 medium-12">
            <div class="row dropdown-select">
              <div class="small-12 medium-6 columns">
                <label class="label-name label-top">Tags</label>
                <label *ngIf="displayTags">
                  <app-tpiq-select-dropdown (onValueSelect)="onTagSelect($event)" [includeNone]="false" [setData]="tagsList"
                                            [setPlaceHolder]="'Tag'" [setSearchKey]="'label'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
                </label>
                <div class="small-12 medium-12 columns float-left multiselect-wrapper">
                  <div *ngFor="let tag of searchModel.selectedTags;let i = index" class="column small-12 medium-6 float-left margin-top-10">
                    <span class="radius secondary label selected-label">
                      <span class="label-name">{{(tag.label) ? tag.label : ''}}</span>
                      <span (click)="removeFromSelectedList($event, i, searchModel.selectedTags)" class="pointer remove-selected">
                        <i class="icon ion-close-round"></i>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="small-12 medium-6 columns">
                <label class="label-name label-top">Status</label>
                <label>
                  <app-tpiq-select-dropdown (onValueSelect)="setStatus($event)" [includeNone]="false" [setData]="statusTypes"
                                            [setDefaultValue]="searchModel.status || ''" [setPlaceHolder]="'Status'" [setSearchKey]="'name'"
                                            [setValueKey]="'name'"></app-tpiq-select-dropdown>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row row-padding-reveal">
          <div class="small-12 medium-12">
            <div class="row dropdown-select">
              <div class="small-12 medium-6 columns">
                <label class="label-name label-top">Category</label>
                <div>
                  <div class="multi-select-dropdown" (click)="$event.stopImmediatePropagation()">
                    <div class="multi-select-trigger" (click)="toggleMultiSelect($event, 'category')">
                      <span class="multi-select-placeholder">Category</span>
                      <i class="material-icons multi-select-arrow" [class.open]="isMultiSelectOpen('category')">arrow_drop_down</i>
                    </div>
                    <div *ngIf="isMultiSelectOpen('category')" class="multi-select-menu">
                      <div class="multi-select-menu-title">Select one or more</div>
                      <label *ngFor="let option of categoryOptions" class="multi-select-option" (click)="$event.stopImmediatePropagation()">
                        <input type="checkbox" [checked]="isOptionSelected('category', option)"
                               (change)="onMultiSelectOptionChange('category', option, $event)">
                        <span>{{ getOptionLabel(option) }}</span>
                      </label>
                    </div>
                    <div *ngIf="getSelectedOptions('category').length" class="selected-filter-chips">
                      <span *ngFor="let selected of getSelectedOptions('category'); trackBy: trackByOptionValue" class="selected-filter-chip">
                        <span>{{ selected.label }}</span>
                        <i class="icon ion-close-round" (click)="removeMultiSelectValue('category', selected.value, $event)"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="small-12 medium-6 columns">
                <label class="label-name label-top">Complexity</label>
                <div>
                  <div class="multi-select-dropdown" (click)="$event.stopImmediatePropagation()">
                    <div class="multi-select-trigger" (click)="toggleMultiSelect($event, 'complexity')">
                      <span class="multi-select-placeholder">Complexity</span>
                      <i class="material-icons multi-select-arrow" [class.open]="isMultiSelectOpen('complexity')">arrow_drop_down</i>
                    </div>
                    <div *ngIf="isMultiSelectOpen('complexity')" class="multi-select-menu">
                      <div class="multi-select-menu-title">Select one or more</div>
                      <label *ngFor="let option of complexityOptions" class="multi-select-option" (click)="$event.stopImmediatePropagation()">
                        <input type="checkbox" [checked]="isOptionSelected('complexity', option)"
                               (change)="onMultiSelectOptionChange('complexity', option, $event)">
                        <span>{{ getOptionLabel(option) }}</span>
                      </label>
                    </div>
                    <div *ngIf="getSelectedOptions('complexity').length" class="selected-filter-chips">
                      <span *ngFor="let selected of getSelectedOptions('complexity'); trackBy: trackByOptionValue" class="selected-filter-chip">
                        <span>{{ selected.label }}</span>
                        <i class="icon ion-close-round" (click)="removeMultiSelectValue('complexity', selected.value, $event)"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row row-padding-reveal">
          <div class="small-12 medium-12">
            <div class="row dropdown-select">
              <div class="small-12 medium-6 columns">
                <label class="label-name label-top">Urgency</label>
                <div>
                  <div class="multi-select-dropdown" (click)="$event.stopImmediatePropagation()">
                    <div class="multi-select-trigger" (click)="toggleMultiSelect($event, 'urgency')">
                      <span class="multi-select-placeholder">Urgency</span>
                      <i class="material-icons multi-select-arrow" [class.open]="isMultiSelectOpen('urgency')">arrow_drop_down</i>
                    </div>
                    <div *ngIf="isMultiSelectOpen('urgency')" class="multi-select-menu">
                      <div class="multi-select-menu-title">Select one or more</div>
                      <label *ngFor="let option of urgencyOptions" class="multi-select-option" (click)="$event.stopImmediatePropagation()">
                        <input type="checkbox" [checked]="isOptionSelected('urgency', option)"
                               (change)="onMultiSelectOptionChange('urgency', option, $event)">
                        <span>{{ getOptionLabel(option) }}</span>
                      </label>
                    </div>
                    <div *ngIf="getSelectedOptions('urgency').length" class="selected-filter-chips">
                      <span *ngFor="let selected of getSelectedOptions('urgency'); trackBy: trackByOptionValue" class="selected-filter-chip">
                        <span>{{ selected.label }}</span>
                        <i class="icon ion-close-round" (click)="removeMultiSelectValue('urgency', selected.value, $event)"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="small-12 medium-6 columns">
                <label class="label-name label-top">Risk</label>
                <div>
                  <div class="multi-select-dropdown" (click)="$event.stopImmediatePropagation()">
                    <div class="multi-select-trigger" (click)="toggleMultiSelect($event, 'riskLevel')">
                      <span class="multi-select-placeholder">Risk</span>
                      <i class="material-icons multi-select-arrow" [class.open]="isMultiSelectOpen('riskLevel')">arrow_drop_down</i>
                    </div>
                    <div *ngIf="isMultiSelectOpen('riskLevel')" class="multi-select-menu">
                      <div class="multi-select-menu-title">Select one or more</div>
                      <label *ngFor="let option of riskOptions" class="multi-select-option" (click)="$event.stopImmediatePropagation()">
                        <input type="checkbox" [checked]="isOptionSelected('riskLevel', option)"
                               (change)="onMultiSelectOptionChange('riskLevel', option, $event)">
                        <span>{{ getOptionLabel(option) }}</span>
                      </label>
                    </div>
                    <div *ngIf="getSelectedOptions('riskLevel').length" class="selected-filter-chips">
                      <span *ngFor="let selected of getSelectedOptions('riskLevel'); trackBy: trackByOptionValue" class="selected-filter-chip">
                        <span>{{ selected.label }}</span>
                        <i class="icon ion-close-round" (click)="removeMultiSelectValue('riskLevel', selected.value, $event)"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row row-padding-reveal">
          <div class="small-12 medium-12">
            <div class="row dropdown-select">
              <div class="small-12 medium-6 columns">
                <label class="label-name label-top">Burden</label>
                <div>
                  <div class="multi-select-dropdown" (click)="$event.stopImmediatePropagation()">
                    <div class="multi-select-trigger" (click)="toggleMultiSelect($event, 'burden')">
                      <span class="multi-select-placeholder">Burden</span>
                      <i class="material-icons multi-select-arrow" [class.open]="isMultiSelectOpen('burden')">arrow_drop_down</i>
                    </div>
                    <div *ngIf="isMultiSelectOpen('burden')" class="multi-select-menu">
                      <div class="multi-select-menu-title">Select one or more</div>
                      <label *ngFor="let option of burdenOptions" class="multi-select-option" (click)="$event.stopImmediatePropagation()">
                        <input type="checkbox" [checked]="isOptionSelected('burden', option)"
                               (change)="onMultiSelectOptionChange('burden', option, $event)">
                        <span>{{ getOptionLabel(option) }}</span>
                      </label>
                    </div>
                    <div *ngIf="getSelectedOptions('burden').length" class="selected-filter-chips">
                      <span *ngFor="let selected of getSelectedOptions('burden'); trackBy: trackByOptionValue" class="selected-filter-chip">
                        <span>{{ selected.label }}</span>
                        <i class="icon ion-close-round" (click)="removeMultiSelectValue('burden', selected.value, $event)"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="small-12 medium-6 columns">
                <label class="label-name label-top">Amount Type</label>
                <div>
                  <div class="multi-select-dropdown" (click)="$event.stopImmediatePropagation()">
                    <div class="multi-select-trigger" (click)="toggleMultiSelect($event, 'amountType')">
                      <span class="multi-select-placeholder">Amount Type</span>
                      <i class="material-icons multi-select-arrow" [class.open]="isMultiSelectOpen('amountType')">arrow_drop_down</i>
                    </div>
                    <div *ngIf="isMultiSelectOpen('amountType')" class="multi-select-menu">
                      <div class="multi-select-menu-title">Select one or more</div>
                      <label *ngFor="let option of amountTypeOptions" class="multi-select-option" (click)="$event.stopImmediatePropagation()">
                        <input type="checkbox" [checked]="isOptionSelected('amountType', option)"
                               (change)="onMultiSelectOptionChange('amountType', option, $event)">
                        <span>{{ getOptionLabel(option) }}</span>
                      </label>
                    </div>
                    <div *ngIf="getSelectedOptions('amountType').length" class="selected-filter-chips">
                      <span *ngFor="let selected of getSelectedOptions('amountType'); trackBy: trackByOptionValue" class="selected-filter-chip">
                        <span>{{ selected.label }}</span>
                        <i class="icon ion-close-round" (click)="removeMultiSelectValue('amountType', selected.value, $event)"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row row-padding-reveal">
          <div class="small-12 medium-12">
            <div class="row dropdown-select">
              <div class="small-12 medium-6 columns">
                <label class="label-name label-top">Requires Investment?</label>
                <label>
                  <app-tpiq-select-dropdown (onValueSelect)="setRequiresInvestment($event)" [includeNone]="false" [setData]="requiresInvestmentOptions"
                                            [setDefaultValue]="searchModel.requiresInvestment || ''" [setPlaceHolder]="'Requires Investment?'" [setSearchKey]="'label'"
                                            [setValueKey]="'value'"></app-tpiq-select-dropdown>
                </label>
              </div>
              <div class="small-12 medium-6 columns">
                <label class="label-name label-top">Applicable To</label>
                <label>
                  <app-tpiq-select-dropdown (onValueSelect)="setApplicableTo($event)" [includeNone]="false" [setData]="applicableToOptions"
                                            [setDefaultValue]="searchModel.applicableTo || ''" [setPlaceHolder]="'Applicable To'" [setSearchKey]="'label'"
                                            [setValueKey]="'value'"></app-tpiq-select-dropdown>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row" style="padding-top: 1rem;">
          <div class="small-12 medium-12 columns text-right">
            <button (click)="clearAllFilters()" class="button small clear-button" type="button">Clear</button>
            <button (click)="advanceTasksSearch()" class="button small post-button" data-close type="submit">Search
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
